const useCheckRefund = (canRefund1: boolean | undefined, canRefund2: boolean | undefined,
  expireDateTime1: string | Date | undefined, expireDateTime2: string | Date | undefined, canSupportRefund1: boolean | undefined, canSupportRefund2: boolean | undefined) => {
  const expireDateTime = canRefund2
    ? expireDateTime2
    : canRefund1
      ? expireDateTime1
      : new Date();

  let type = 'accept-pending';

  if (canSupportRefund2 && !canSupportRefund1) {
    if (canRefund2) type = 'accept-not-pending';
    else type = 'pending-reject';
  }

  if (canSupportRefund2 && canSupportRefund1) {
    if (canRefund2 && canRefund1) type = 'accept-pending';
    if (!canRefund2 && canRefund1) type = 'pending-accept';
    if (!canRefund2 && !canRefund1) type = 'pending-reject';
  }
  if (!canSupportRefund2 && !canSupportRefund1) type = 'reject-all';
  return {
    type,
    expireDateTime,
  };
};

export default useCheckRefund;
